// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lang-icon {
  position: fixed;
  top: 25%;
  right: 0;
  height: 22px;
  width: 22px;
  border: 2px solid white;
  border-radius: 50%;
}

ion-content {
  position: relative;
  --overflow: hidden;
}

.wrapper {
  background: #231f20;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
}
.wrapper .card {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 30px 20px;
}
.wrapper .title {
  width: 100%;
  margin-bottom: 5px;
  font-size: 38px;
  font-weight: 700;
  font-family: var(--ion-font-family);
  line-height: 120%;
  color: #fff;
}
.wrapper .button {
  width: 100%;
  min-height: 50px;
}
@media (min-width: 991px) {
  .wrapper .button {
    padding: 0;
  }
  .wrapper .button ion-button {
    width: 100%;
    height: 58px;
  }
}
.wrapper ion-button {
  --border-width: 0px;
  --background: var(--ion-color-white);
}
.wrapper ion-button:hover {
  color: var(--ion-color-black);
  --border-width: 1px;
  --border-color: #fff;
  --border-style: solid;
}
.wrapper ion-button .button-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.wrapper ion-button .button-inner .button-text {
  padding-top: 8px;
  font-size: 18px;
  line-height: 130%;
  font-weight: 700;
  font-family: var(--ion-font-family);
  text-transform: none;
}

.info {
  font-size: 20px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0px;
  color: #fff;
  margin-bottom: 20px;
  font-family: var(--ion-font-family);
}

.home-bg {
  background-image: url('home-page.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 49%;
}
.home-bg .bottom-line {
  clip-path: polygon(40px 0, 100% 0, 100% 100%, 0 100%, 0 43px);
  background-image: url('bottom-line-home.png');
  background-color: #231f20;
  background-size: contain;
  background-repeat: repeat-x;
  width: 100%;
  height: 45px;
  position: absolute;
  bottom: 51%;
}
.home-bg.eintracht {
  position: relative;
  background-image: url('email-confiramation-eintracht-header-bg.png');
  background-size: cover;
  background-position: 56% top;
  height: 100dvh;
}
.home-bg.eintracht::before {
  content: "";
  background: rgba(0, 0, 0, 0.75);
  display: block;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1;
}

.eintracht ion-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
}
.eintracht ion-toolbar {
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  --background: transparent;
  --min-height: 0;
  --padding-top: 10px;
  --padding-bottom: 0;
  --padding-start: 15px;
  --padding-end: 15px;
  background: transparent;
}
.eintracht .lang-icon {
  width: 27px;
  height: 27px;
  margin: 2px 15px 0 0;
  border: 2px solid #ffffff;
  border-radius: 50%;
  filter: grayscale(1);
}
.eintracht .club-logo {
  display: block;
  width: 36px;
  height: 35px;
}
.eintracht ion-content {
  z-index: 2;
  --background: transparent;
  --padding-start: 20px;
  --padding-end: 20px;
  height: 100%;
}
.eintracht ion-content .card {
  position: relative;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 25px;
}
.eintracht ion-content .card .presented-block {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 222px;
  transform: translateY(-50%);
  overflow: hidden;
  background: #191919;
  border-radius: 20px;
}
.eintracht ion-content .card .click-collect-title {
  position: absolute;
  top: 22px;
  left: -13px;
  width: 269px;
  font-family: AppFont, sans-serif;
  font-weight: 700;
  font-size: 61.4768px;
  line-height: 90%;
  letter-spacing: -0.004em;
  text-transform: uppercase;
  color: #ffffff;
  -webkit-text-stroke: 2.4px #ffffff;
}
.eintracht ion-content .card .presented-by {
  position: absolute;
  top: 147px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.eintracht ion-content .card .presented-by .presented-by-label {
  font-family: AppFont, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 90%;
  letter-spacing: -0.03em;
  color: #ffffff;
}
.eintracht ion-content .card .presented-by .amex-logo {
  display: block;
  width: 134px;
  height: 38px;
}
.eintracht ion-content .card ion-button {
  --background: var(--ion-color-eintracht-red);
  --border-width: 0px;
  --border-radius: 6px;
  --box-shadow: none;
  height: 50px;
  margin: 0;
  letter-spacing: 0;
  color: #ffffff;
}
.eintracht ion-content .card ion-button .button-text {
  margin: 0;
  font-family: AppFontEintrachtOFCSans;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  text-transform: none;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACC,eAAA;EACA,QAAA;EACA,QAAA;EAEA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AAHD;;AAMA;EACC,kBAAA;EACA,kBAAA;AAHD;;AAMA;EACC,mBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAHD;AAUC;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AARF;AAUC;EACC,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,WAAA;AARF;AAWC;EACC,WAAA;EACA,gBAAA;AATF;AC5CE;EDmDD;IAKE,UAAA;EARD;EASC;IACC,WAAA;IACA,YAAA;EAPF;AACF;AAWC;EACC,mBAAA;EACA,oCAAA;AATF;AAWE;EACC,6BAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AATH;AAYE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAVH;AAYG;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mCAAA;EACA,oBAAA;AAVJ;;AAgBA;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;AAbD;;AAeA;EACC,sCAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;AAZD;AAcC;EACC,6DAAA;EACA,6CAAA;EACA,yBAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAZF;AAgBC;EACC,kBAAA;EACA,oEAAA;EACA,sBAAA;EACA,4BAAA;EAUA,cAAA;AAvBF;AAcE;EACC,WAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAZH;;AAkBC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AAfF;AAkBC;EACC,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;AAkBC;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAhBF;AAkBC;EACC,cAAA;EACA,WAAA;EACA,YAAA;AAhBF;AAkBC;EACC,UAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAhBF;AAiBE;EACC,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;AAfH;AAiBG;EACC,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAfJ;AAkBG;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EAEA,wBAAA;EACA,yBAAA;EACA,cAAA;EAEA,kCAAA;AAlBJ;AAqBG;EACC,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAnBJ;AAqBI;EACC,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAnBL;AAsBI;EACC,cAAA;EACA,YAAA;EACA,YAAA;AApBL;AAwBG;EACC,4CAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAtBJ;AAuBI;EACC,SAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AArBL","sourcesContent":["@import '../../../theme/mixins';\n\n// Deutsche Bank Park Styles\n.lang-icon {\n\tposition: fixed;\n\ttop: 25%;\n\tright: 0;\n\n\theight: 22px;\n\twidth: 22px;\n\tborder: 2px solid white;\n\tborder-radius: 50%;\n}\n\nion-content {\n\tposition: relative;\n\t--overflow: hidden;\n}\n\n.wrapper {\n\tbackground: #231f20;\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tflex-direction: column;\n\tmargin: 0 auto;\n\n\t@include desktop {\n\t\t// width: 640px;\n\t\t// height: 100%;\n\t}\n\n\t.card {\n\t\twidth: 100%;\n\t\tmax-width: 500px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: flex-start;\n\t\tpadding: 30px 20px;\n\t}\n\t.title {\n\t\twidth: 100%;\n\t\tmargin-bottom: 5px;\n\t\tfont-size: 38px;\n\t\tfont-weight: 700;\n\t\tfont-family: var(--ion-font-family);\n\t\tline-height: 120%;\n\t\tcolor: #fff;\n\t}\n\n\t.button {\n\t\twidth: 100%;\n\t\tmin-height: 50px;\n\n\t\t@include desktop {\n\t\t\tpadding: 0;\n\t\t\tion-button {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 58px;\n\t\t\t}\n\t\t}\n\t}\n\n\tion-button {\n\t\t--border-width: 0px;\n\t\t--background: var(--ion-color-white);\n\t\t\n\t\t&:hover {\n\t\t\tcolor: var(--ion-color-black);\n\t\t\t--border-width: 1px;\n\t\t\t--border-color: #fff;\n\t\t\t--border-style: solid;\n\t\t}\n\n\t\t.button-inner {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\n\t\t\t.button-text {\n\t\t\t\tpadding-top: 8px;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 130%;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-family: var(--ion-font-family);\n\t\t\t\ttext-transform: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.info {\n\tfont-size: 20px;\n\tfont-weight: 500;\n\tline-height: 100%;\n\tletter-spacing: 0px;\n\tcolor: #fff;\n\tmargin-bottom: 20px;\n\tfont-family: var(--ion-font-family);\n}\n.home-bg {\n\tbackground-image: url(../../../assets/eintracht/home-page.png);\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\twidth: 100%;\n\theight: 49%;\n\n\t.bottom-line {\n\t\tclip-path: polygon(40px 0, 100% 0, 100% 100%, 0 100%, 0 43px);\n\t\tbackground-image: url(../../../assets/eintracht/bottom-line-home.png);\n\t\tbackground-color: #231f20;\n\t\tbackground-size: contain;\n\t\tbackground-repeat: repeat-x;\n\t\twidth: 100%;\n\t\theight: 45px;\n\t\tposition: absolute;\n\t\tbottom: 51%;\n\t}\n\n// Eintracht styles\n\t&.eintracht {\n\t\tposition: relative;\n\t\tbackground-image: url(../../../assets/eintracht/email-confiramation-eintracht-header-bg.png);\n\t\tbackground-size: cover;\n\t\tbackground-position: 56% top;\n\t\t&::before {\n\t\t\tcontent: \"\";\n\t\t\tbackground: rgba(0, 0, 0, 0.75);\n\t\t\tdisplay: block;\n\t\t\theight: 100%;\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\tz-index: 1;\n\t\t}\n\t\theight: 100dvh;\n\t}\n}\n.eintracht {\n\tion-header {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tz-index: 3;\n\t}\n\t// global.scss forces padding-top: max(safe-area, 7px) on every toolbar\n\tion-toolbar {\n\t\tpadding-right: 0;\n\t\tpadding-bottom: 0;\n\t\tpadding-left: 0;\n\t\t--background: transparent;\n\t\t--min-height: 0;\n\t\t--padding-top: 10px;\n\t\t--padding-bottom: 0;\n\t\t--padding-start: 15px;\n\t\t--padding-end: 15px;\n\t\tbackground: transparent;\n\t}\n\t.lang-icon {\n\t\twidth: 27px;\n\t\theight: 27px;\n\t\tmargin: 2px 15px 0 0;\n\t\tborder: 2px solid #ffffff;\n\t\tborder-radius: 50%;\n\t\tfilter: grayscale(1);\n\t}\n\t.club-logo {\n\t\tdisplay: block;\n\t\twidth: 36px;\n\t\theight: 35px;\n\t}\n\tion-content {\n\t\tz-index: 2;\n\t\t--background: transparent;\n\t\t--padding-start: 20px;\n\t\t--padding-end: 20px;\n\t\theight: 100%;\n\t\t.card {\n\t\t\tposition: relative;\n\t\t\theight: 100dvh;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: flex-end;\n\t\t\tpadding-bottom: 25px;\n\n\t\t\t.presented-block {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\theight: 222px;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\toverflow: hidden;\n\t\t\t\tbackground: #191919;\n\t\t\t\tborder-radius: 20px;\n\t\t\t}\n\n\t\t\t.click-collect-title {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 22px;\n\t\t\t\tleft: -13px;\n\t\t\t\twidth: 269px;\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-size: 61.4768px;\n\t\t\t\tline-height: 90%;\n\t\t\t\t// -0.03em in Figma, loosened to make up for the narrower Bold cut\n\t\t\t\tletter-spacing: -0.004em;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\t// Figma uses Nimbus Sans Round Black (900); only Bold ships with the app, so thicken the strokes\n\t\t\t\t-webkit-text-stroke: 2.4px #ffffff;\n\t\t\t}\n\n\t\t\t.presented-by {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 147px;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 8px;\n\n\t\t\t\t.presented-by-label {\n\t\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tline-height: 90%;\n\t\t\t\t\tletter-spacing: -0.03em;\n\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t}\n\n\t\t\t\t.amex-logo {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\twidth: 134px;\n\t\t\t\t\theight: 38px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-button {\n\t\t\t\t--background: var(--ion-color-eintracht-red);\n\t\t\t\t--border-width: 0px;\n\t\t\t\t--border-radius: 6px;\n\t\t\t\t--box-shadow: none;\n\t\t\t\theight: 50px;\n\t\t\t\tmargin: 0;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\t.button-text {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tfont-family: AppFontEintrachtOFCSans;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 130%;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\ttext-transform: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
